import { UntypedFormControl } from '@angular/forms';
import { Items } from 'src/app/core/models/common/items.model';

export const DISPLAY_TEXT = {
  WELCOME_TEXT: $localize`Location Group Admin`,
  VIEW_SITE: $localize`View Sites`,
  ENTER: $localize`Enter Site`,
  SEARCH_DESC_PLACEHOLDER: $localize`Search Description`,
  SEARCH_GROUP_PLACEHOLDER: $localize`Search Group`,
};
export interface LinkedSite {
  id: number;
  code: string;
  name: string;
  slic: string;
}
export type LocationGroupTableData = {
  group: string;
  description: string;
  noOfSites: number;
  checked: boolean;
  linkedSites: LinkedSite[];
  selectedIndex?: number;
  code: string;
  name: string;
  id: number;
  version: number;
};

export type ColumnData = {
  itemId: string;
  ids: Items[];
  checkAllIds: boolean;
  searchResults: Items[];
  activeFilterIds: Items[];
  formControl: UntypedFormControl;
};

export enum ColumnIds {
  GROUP = 'code',
  DESCRIPTION = 'name',
  NOOFSITES = 'numberOfSites',
  ACTION = 'action',
  LINKED_SITES = 'linkedSites',
  SLIC = 'slic',
}

export const ColumnText = {
  GROUP: $localize`Group Code`.toUpperCase(),
  DESCRIPTION_COL: $localize`Group Name`.toUpperCase(),
  NUMBER_OF_SITES: $localize`Number of Sites`.toUpperCase(),
  ACTION: $localize`Actions`.toUpperCase(),
  LINKED_SITES: $localize`Linked Sites`.toUpperCase(),
  SLIC: $localize`SLIC`.toUpperCase(),
  NAME_OR_DESC: $localize`Description`.toUpperCase(),
};

export const EXCEL_COLUMNS = [
  $localize`Group`.toUpperCase(),
  $localize`Description`.toUpperCase(),
  $localize`Linked Sites`.toUpperCase(),
  $localize`SLIC`.toUpperCase(),
];

export const ADD = `add`;

export const EXCEL_FILE_NAME = 'location-group-data';

export const GROUP_WARNING_MODAL = {
  HEADER: $localize`Remove Group`,
  BODY: $localize`Are you sure you want to remove the following Group: `,
  CONFIRMATION: $localize`Yes`,
  REJECT: $localize`No`,
};

export const DISPLAYED_COLUMNS = ['code', 'name', 'numberOfSites', 'action'];

export enum ACTION_TYPE {
  DELETE = 'DELETE',
}

export type LocationGroupExcelDataType = Partial<LocationGroupTableData>;
